import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import Img from '@/lib/Img'

const ImageItem = ({ image, _rawRichtext }) => (
	<article className="mb-10">
		<div className="grid md:grid-cols-[150px,1fr] items-center gap-y-4 gap-x-8">
			<Img className="flex grow <md:h-[100px]" image={image} objectFit="contain" />
			<Richtext className="font-serif text-3xl <md:text-2xl richtext" raw={_rawRichtext} />
		</div>
	</article>
)

const ImageTwoColumn = ({ heading, style, items, blockId }) => {
	const styleClass =
		style === 'grounding-navy' ? 'bg-grounding-navy text-caribbean' :
		style === 'light-blue' ? 'bg-light-blue' :
		style === 'caribbean' ? 'bg-caribbean' :
		null

	return (
		<section id={blockId} className={styleClass}>
			<div className="max-w-screen-xl mx-auto grid md:grid-cols-2 md:grid-rows-1 gap-8 items-center py-24 px-4">
				<HTag className="font-serif font-bold text-5xl text-center" {...heading} />

				<div className="mx-auto px-4 grid md:grid-rows-3 gap-x-6 <md:text-center">
					{items?.map((item, key) => (
						<ImageItem {...item} key={key} />
					))}
				</div>
			</div>
		</section>
	)
}

export default ImageTwoColumn
